import { getApp, initializeApp } from 'firebase/app';
import { initializeFirestore } from 'firebase/firestore';
import { connectFunctionsEmulator, getFunctions } from 'firebase/functions';
import { connectStorageEmulator, getStorage } from 'firebase/storage';
import { firebaseConfig } from './config';

const app = initializeApp(firebaseConfig);

initializeFirestore(app, {
  ignoreUndefinedProperties: true,
});

if (process.env.NODE_ENV !== 'production') {
  connectFunctionsEmulator(getFunctions(app), 'localhost', 5001);
  connectStorageEmulator(getStorage(app), 'localhost', 9199);
}

export const compatFirebaseApp = app;

export function getFirebaseApp() {
  return getApp();
}
